import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Switch } from '../../../../common/html/switch'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../../utils/authorization'
import { selectProfileById } from '../../store/slice'
import { changeSettingTable, selectDataTable } from '../store/slice'

export const SwitchCell = ({ rowId, isCreate }) => {
  const dispatch = useDispatch()
  const [search] = useSearchParams()
  const id = search.get('profileId')

  const isDefaultProfile = useSelector(
    selectProfileById(+id, 'isDefaultProfile'),
  )
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)
  const dataRow = useSelector(selectDataTable(rowId))

  const allowChange =
    AUTHORIZATION_API.alerts.settings.changeRules[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW &&
    !isDefaultProfile &&
    !dataRow.disabled

  const onChange = (isCheck) => {
    dispatch(
      changeSettingTable({
        id: rowId,
        value: {
          ...dataRow,
          sendNotification: isCheck,
        },
      }),
    )
  }

  return (
    <Switch
      checked={dataRow.sendNotification}
      onChange={onChange}
      allowChange={allowChange || isCreate}
    />
  )
}
